module.exports = __webpack_public_path__ + "static/media/pic_6.65b20253.jpg";